module.exports = __webpack_public_path__ + "img/20190523192412微信截图_20190523192750.bb7e1354.png";